// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCallback, useRef } from 'react';
import { getFirstFocusable } from '../internal/components/focus-lock/utils';
/**
 * Moves focus into Dialog when it mounts and restores it on unmount unless the
 * consumer has already moved focus outside Dialog.
 */
export function useFocusRestore() {
    const containerRef = useRef(null);
    const restoreFocusTargetRef = useRef(null);
    return useCallback((container) => {
        var _a, _b;
        if (container) {
            containerRef.current = container;
            restoreFocusTargetRef.current = null;
            // ownerDocument keeps this working when rendered inside an iframe.
            const activeElement = container.ownerDocument.activeElement;
            if (activeElement && !container.contains(activeElement)) {
                restoreFocusTargetRef.current = activeElement;
            }
            (_a = getFirstFocusable(container)) === null || _a === void 0 ? void 0 : _a.focus();
            return;
        }
        const mountedContainer = containerRef.current;
        const activeElement = mountedContainer === null || mountedContainer === void 0 ? void 0 : mountedContainer.ownerDocument.activeElement;
        if (mountedContainer && activeElement && mountedContainer.contains(activeElement)) {
            (_b = restoreFocusTargetRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        containerRef.current = null;
        restoreFocusTargetRef.current = null;
    }, []);
}
//# sourceMappingURL=use-focus-restore.js.map